import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}

// function formatCurrency(value: number, currency = "USD"): string {
//   return new Intl.NumberFormat("en-US", {
//     style: "currency",
//     currency,
//     maximumFractionDigits: 0,
//   }).format(value)
// }

// function formatNumber(value: number): string {
//   return new Intl.NumberFormat("en-US").format(value)
// }

// function slugify(text: string): string {
//   return text
//     .toLowerCase()
//     .replace(/[^\w ]+/g, "")
//     .replace(/ +/g, "-")
// }

// function truncate(text: string, length: number): string {
//   if (text.length <= length) return text
//   return text.slice(0, length) + "..."
// }
